import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { AuthRoutes } from "./AuthRoutes";
import PrivateRoute from "./PrivateRoute";
import { ApplicationRoutes } from "./ApplicationRoutes";
import firebase from "../Firebase/firebase";
import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  HttpLink,
  NormalizedCacheObject,
} from "@apollo/client";

interface RoutesProps {
  user: firebase.User | null | undefined;
}

interface RoutesState {
  user: firebase.User | null | undefined;
  client: ApolloClient<NormalizedCacheObject>;
}

const DEFAULT_STATE: RoutesState = {
  user: null,
  client: new ApolloClient({
    link: new HttpLink({
      uri: "https://hasura-dev.ioloc.co.za/v1/graphql",
    }),
    cache: new InMemoryCache(),
  }),
};
const Routes = (props: RoutesProps) => {
  const [state, setState] = useState(DEFAULT_STATE);
  const createApolloClient = (authToken: string) => {
    return new ApolloClient({
      link: new HttpLink({
        uri: "https://hasura-dev.ioloc.co.za/v1/graphql",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }),
      cache: new InMemoryCache(),
    });
  };

  useEffect(() => {
    console.log(props.user);
    const user = props.user;
    async function updateToken() {
      const token = await user?.getIdToken();
      const idTokenResult = await user?.getIdTokenResult();
      const hasuraClaim = idTokenResult?.claims["https://hasura.io/jwt/claims"];
      if (!!hasuraClaim && !!token) {
        const client = createApolloClient(token);
        setState({ ...state, client: client, user: user });
      }
    }
    if (!!user?.getIdToken) {
      updateToken();
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [props.user]);
  return (
    <Router>
      <ApolloProvider client={state.client}>
        <Switch>
          <PrivateRoute path="/app" component={ApplicationRoutes} />
          <Route path="/auth" component={AuthRoutes} />
          <Redirect to="/auth" from="/" />
        </Switch>
      </ApolloProvider>
    </Router>
  );
};
export default Routes;
